export default {
  buttons: {
    next: "Siguiente",
    prev: "Atrás",
    skip: "Saltar",
    done: "Hecho",
    gotIt: "Entendido",
  },
  messages: {
    dontShowAgainLabel: "No mostrar esto de nuevo",
    stepNumbersOfLabel: "de",
  },
};
